/* TALINA BEACH — avisos demonstrativos de tamanho.
   Os textos de demonstração não refletem inventário da Shopify.
   Na vitrine pública, qualquer exemplo de escassez é identificado como ilustrativo.
   O controle alterna a legenda completa ou a etiqueta curta 'Simulação' no site público.
   No editor, pode ocultar a legenda totalmente para visualizar o layout. */
(function () {
  "use strict";
  var selector = "[data-talina-tag-teste]";
  var timer = null;
  function clean(value) { return String(value || "").trim().toUpperCase(); }
  function selectedSize(notice) {
    var group = notice.closest(".product-form__option-selector");
    if (!group) return "";
    var position = notice.dataset.optionPosition;
    var input = group.querySelector('input[name="option' + position + '"]:checked') ||
                group.querySelector('select[name="option' + position + '"]');
    if (input) return clean(input.value);
    var chosen = group.querySelector(".product-form__option-value, .select__selected-value");
    return chosen ? clean(chosen.textContent) : "";
  }
  function messageFor(notice, size) {
    if (!size || size === "P") return "";
    if (notice.dataset.exemploPublico === "false") return "Confira a disponibilidade do tamanho " + size + ".";
    var key = {M:"visualM", G:"visualG", GG:"visualGg", G2:"visualG2", G3:"visualG3"}[size];
    var configured = key ? notice.dataset[key] : notice.dataset.visualOutros;
    var fallback = size === "M" ? "Restam apenas 5 unidades!" :
      size === "G" ? "Restam apenas 8 unidades!" : "Quase esgotado";
    return String(configured || fallback).split("{tamanho}").join(size);
  }
  function inEditor() { return !!(window.Shopify && window.Shopify.designMode); }
  function render() {
    document.querySelectorAll(selector).forEach(function(notice) {
      var size = selectedSize(notice);
      var isEnabled = notice.dataset.ativo !== "false";
      var message = isEnabled ? messageFor(notice, size) : "";
      var text = notice.querySelector("[data-talina-tag-mensagem]");
      var caption = notice.querySelector("[data-talina-premium-exemplo-label]");
      var demonstracao = notice.dataset.exemploPublico !== "false";
      if (text) text.textContent = message;
      if (caption) {
        var showOriginal = notice.dataset.mostrarRotulo !== "false";
        caption.textContent = showOriginal ? "Exemplo visual — não representa estoque real" : "";
        var captionVisible = !!message && demonstracao && showOriginal;
        caption.style.display = captionVisible ? "block" : "none";
      }
      notice.style.display = message ? "flex" : "none";
    });
  }
  function schedule() {
    if (timer !== null) window.clearTimeout(timer);
    timer = window.setTimeout(function(){ timer = null; render(); }, 40);
    window.setTimeout(render, 180);
  }
  document.addEventListener("change", function(e) {
    if (e.target.closest && e.target.closest("product-variants")) schedule();
  }, true);
  document.addEventListener("click", function(e) {
    if (e.target.closest && e.target.closest("product-variants")) schedule();
  }, true);
  ["variant:changed","variant:change","shopify:section:load"].forEach(function(evt) {
    document.addEventListener(evt, schedule);
  });
  window.addEventListener("popstate", schedule);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", render, {once:true});
  else render();
  if (window.MutationObserver) {
    new MutationObserver(function(records) {
      if (records.some(function(record) {
        return Array.prototype.some.call(record.addedNodes || [], function(el) {
          return el.nodeType === 1 && ((el.matches && el.matches(selector)) ||
            (el.querySelector && el.querySelector(selector)));
        });
      })) schedule();
    }).observe(document.documentElement, {childList:true,subtree:true});
  }
})();